export enum FontFaces {
    montserrat = 'Montserrat',
    notoSans = 'Noto Sans',
    openSans = 'Open Sans',
    raleway = 'Raleway',
    roboto = 'Roboto',
}